import { render, staticRenderFns } from "./JdsEntrySlot.vue?vue&type=template&id=669aca8d&scoped=true&"
import script from "./JdsEntrySlot.vue?vue&type=script&lang=ts&"
export * from "./JdsEntrySlot.vue?vue&type=script&lang=ts&"
import style0 from "./JdsEntrySlot.vue?vue&type=style&index=0&id=669aca8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669aca8d",
  null
  
)

export default component.exports